var _path, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModifyRide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41098",
    "data-name": "Group 41098",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.95,
    height: 16.584,
    viewBox: "0 0 69.95 16.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26422",
    "data-name": "Path 26422",
    d: "M88.114,318.438s3.228.185,3.228,2.457v14.127s-.078-2.457-3.228-2.457H21.392l6.457-7.371-6.457-6.756Z",
    transform: "translate(-21.392 -318.438)",
    fill: "#2bc7c9",
    fillRule: "evenodd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Modified",
    transform: "translate(15.525 10)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "EuclidCircularB-Regular, Euclid Circular B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Modified"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyRide);
export default __webpack_public_path__ + "static/media/modify-ride.f52ed5028272a992802acd1eff733a99.svg";
export { ForwardRef as ReactComponent };